export default __webpack_public_path__ + "static/media/photo-woman.b527da69.jpeg";